<div *ngIf="isLoading" class="overlay">
    <mat-progress-spinner
        color="primary"
        mode="indeterminate">
    </mat-progress-spinner>
</div>
